<template>
  <footer id="contact" class="footer">
    <div class="cta container">
      <h2 v-reveal class="cta-title gradient-text">Let's build something<br />from the future.</h2>
      <a v-reveal="100" :href="email" class="chip cta-btn">
        <span class="mini-mark">B</span>
        dev.bizzy@gmail.com
      </a>
    </div>

    <div class="footer-grid container">
      <div class="brand-col">
        <a href="#top" class="brand">
          <span class="brand-mark">B</span>
          Bisrat Tadesse
        </a>
        <p>Software developer in Silver Spring, MD.</p>
        <a :href="email" class="chip small">Get in touch</a>
      </div>

      <div v-for="col in columns" :key="col.title" class="link-col">
        <h4>{{ col.title }}</h4>
        <a
          v-for="l in col.links"
          :key="l.label"
          :href="l.href"
          :target="l.href.startsWith('http') ? '_blank' : null"
          :rel="l.href.startsWith('http') ? 'noopener' : null"
        >{{ l.label }}</a>
      </div>
    </div>

    <div class="footer-bottom container">
      <span>© 2026 Bisrat Tadesse</span>
      <div class="socials">
        <a v-for="s in socials" :key="s.label" :href="s.href" :aria-label="s.label" target="_blank" rel="noopener">
          <font-awesome-icon :icon="s.icon" />
        </a>
      </div>
    </div>

    <div class="corner" aria-hidden="true">
      <span v-for="n in 6" :key="n" class="corner-ring" :style="{ '--n': n }"></span>
      <span class="corner-mark">B</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      email: 'mailto:dev.bizzy@gmail.com',
      columns: [
        {
          title: 'Projects',
          links: [
            { label: 'LifeOS', href: '#lifeos' },
            { label: 'Quant Engine', href: '#quant' },
            { label: 'Jarvis', href: '#jarvis' },
            { label: 'AgendaVue', href: '#agendavue' },
          ],
        },
        {
          title: 'About',
          links: [
            { label: 'Experience', href: '#experience' },
            { label: 'Education', href: '#experience' },
            { label: 'Toolbox', href: '#experience' },
          ],
        },
        {
          title: 'Connect',
          links: [
            { label: 'GitHub', href: 'https://github.com/devbizzy' },
            { label: 'LinkedIn', href: 'https://www.linkedin.com/in/bisrat-tadesse-8a07311bb/' },
            { label: 'Email', href: 'mailto:dev.bizzy@gmail.com' },
          ],
        },
      ],
      socials: [
        { label: 'GitHub', icon: ['fab', 'github'], href: 'https://github.com/devbizzy' },
        { label: 'LinkedIn', icon: ['fab', 'linkedin'], href: 'https://www.linkedin.com/in/bisrat-tadesse-8a07311bb/' },
        { label: 'X', icon: ['fab', 'x-twitter'], href: 'https://twitter.com/bizzytrades' },
        { label: 'Instagram', icon: ['fab', 'instagram'], href: 'https://www.instagram.com/bxzzyy/' },
      ],
    };
  },
};
</script>

<style scoped>
.footer {
  position: relative;
  z-index: 1;
  padding-top: 200px;
  overflow: hidden;
}

.cta {
  text-align: center;
  margin-bottom: 200px;
}

.cta-title {
  font-size: clamp(44px, 7vw, 88px);
  font-weight: 700;
  line-height: 1.02;
  letter-spacing: -0.035em;
  padding-bottom: 6px;
}

.cta-btn {
  margin-top: 36px;
  padding: 10px 20px 10px 10px;
}

.mini-mark,
.brand-mark {
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--text);
  color: var(--bg);
  font-weight: 700;
}

.mini-mark { width: 22px; height: 22px; font-size: 12px; }
.brand-mark { width: 26px; height: 26px; font-size: 15px; }

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
}

.brand-col p {
  margin: 14px 0 22px;
  color: var(--text-dim);
}

.chip.small { padding: 8px 16px; font-size: 13px; }

.link-col {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.link-col h4 {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
}

.link-col a {
  color: var(--text-dim);
  font-size: 15px;
  transition: color 0.2s;
}

.link-col a:hover { color: var(--text); }

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 120px;
  padding-bottom: 40px;
  padding-left: 200px;
  color: var(--text-faint);
  font-size: 14px;
}

.socials { display: flex; gap: 18px; font-size: 18px; }
.socials a { color: var(--text-dim); transition: color 0.2s; }
.socials a:hover { color: var(--text); }

.corner {
  position: absolute;
  left: -110px;
  bottom: -110px;
  width: 220px;
  height: 220px;
  pointer-events: none;
}

.corner-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  width: calc(220px + var(--n) * 50px);
  height: calc(220px + var(--n) * 50px);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, calc(0.12 - var(--n) * 0.015));
  transform: translate(-50%, -50%);
}

.corner-mark {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: start end;
  padding: 34px 44px 0 0;
  border-radius: 50%;
  background: radial-gradient(circle at 70% 30%, #fff, #c4c4cc 60%, #6b6b75);
  color: #141417;
  font-size: 56px;
  font-weight: 700;
}

@media (max-width: 760px) {
  .footer { padding-top: 120px; }
  .cta { margin-bottom: 120px; }
  .footer-grid { grid-template-columns: 1fr 1fr; }
  .brand-col { grid-column: 1 / -1; }
  .footer-bottom { padding-left: 24px; padding-top: 160px; flex-direction: column; gap: 16px; align-items: flex-end; }
}
</style>
